<style>
.my-card {
  margin-bottom: 20px;
}
</style>
<template>
  <InternalNavBar />
<div class="row" style="height: 10vh;"></div>
<div class="row" style="justify-content: center">
<div class="col-6" v-if="verified && filledOutSubjects">
  <q-tabs v-model="tab"
          dense
          class="text-black"
          active-color="white"
          indicator-color="white"
          align="center"
          active-bg-color="teal-5"
          style="margin-top: 3vh; font-family: Montserrat;"
          no-caps
  >
    <q-tab name="upcoming" label="Upcoming Tutoring" />
    <q-tab name="search" label="Search Requests"/>
  </q-tabs>

  <q-tab-panels v-model="tab" animated swipeable>
    <q-tab-panel name="upcoming">
      <p class="text-h4" style="font-family: Montserrat; font-weight: 350"><b>Upcoming</b> tutoring sessions</p>
      <div class="row" style="height: 1vh;"></div>
      <q-scroll-area style="height: 70vh">
        <div v-for="(item, n) in upcomingSessions" v-bind:key="n">
          <q-card class="my-card bg-teal-3" flat bordered style="margin-bottom: 2.5vh">
            <q-item>
              <q-item-section avatar>
                <q-avatar @click="$router.push('/profile/' + item.sessionCreatorUsername)">
                  <img v-bind:src="upcomingSessionsPFPSrcArr[n] === 'blank' ? require(`../assets/blank-avatar.png`) : upcomingSessionsPFPSrcArr[n]">
                </q-avatar>
              </q-item-section>

              <q-item-section>
                <div class="row" style="height: 4vh;">
                  <div class="col-3">
                    <q-item-label style="font-family: Lato">Tutoring {{item.sessionCreator}}</q-item-label>
                    <q-item-label caption style="font-family: Lato">On {{item.sessionTime}}
                    </q-item-label>
                  </div>

                  <q-separator vertical />

                  <div class="col-5" style="padding-left: 0.5vw">
                    <q-item-label class="text-bold" style="font-family: Lato">{{item.sessionSubjects}}</q-item-label>
                    <q-item-label caption class="text-bold" style="font-family: Lato">
                      {{item.sessionBounty}} Credits
                    </q-item-label>
                  </div>
                </div>
              </q-item-section>



            </q-item>

            <q-separator />

            <q-card-section horizontal>
              <div class="col-8">
                <q-card-section>
                  <text style="font-family: Lato; word-break: break-word">{{item.truncatedQuestion}}</text>
                </q-card-section>
              </div>
              <div class="col-2 q-pa-md text-center">
                <q-btn v-if="!upcomingCanJoinSession[n]"
                    round
                    color="red-6"
                    icon="cancel"
                    @click="setCancelSessionDialog(n)"
                />
                <q-btn v-else
                       round
                       color="grey-6"
                       icon="meeting_room"
                       @click="$router.replace('/session/' + item.sessionURL)"
                />
                <q-item-label caption class="text-bold" style="margin-top: 1vh; font-family: Lato" v-if="!upcomingCanJoinSession[n]">
                  Cancel Session
                </q-item-label>
                <q-item-label caption class="text-bold" style="margin-top: 1vh; font-family: Lato" v-else>
                  Join Session
                </q-item-label>
              </div>
              <div class="col-2 q-pa-md text-center">
                <q-btn
                    round
                    color="deep-orange-10"
                    icon="assignment"
                    @click="setUpcomingMoreInfoDialog(n)"
                />
                <q-item-label caption class="text-bold" style="margin-top: 1vh; font-family: Lato;">
                  More Info
                </q-item-label>
              </div>
            </q-card-section>
          </q-card>

        <q-dialog v-model="upcomingMoreInfoDialog[n]" no-esc-dismiss no-backdrop-dismiss>
          <q-card flat bordered style="width: 40vw">
            <q-card-section>
              <div class="text-h5 q-mb-xs-xs" style="font-family: Lato">Session Info</div>
            </q-card-section>
            <q-separator />
            <q-card-section style="padding-top: 0.5vh">
              <p class="text-caption text-teal-10 " style="font-family: Lato; word-wrap: break-word"><b>Question</b>: <text class="text-black">{{item.sessionQuestion}}</text></p>
              <p class="text-caption text-teal-10" style="font-family: Lato"><b>Date</b>: <text class="text-black">{{item.sessionTime.substr(0, 12)}}</text></p>
              <p class="text-caption text-teal-10" style="font-family: Lato"><b>Time</b>: <text class="text-black">{{item.sessionTime.substr(12)}}</text></p>
              <p class="text-caption text-teal-10" style="font-family: Lato"><b>Subjects</b>: <text class="text-black">{{item.sessionSubjects}}</text></p>
              <p class="text-caption text-teal-10" style="font-family: Lato"><b>Bounty</b>: <text class="text-black">{{item.sessionBounty}}</text></p>
              <p class="text-caption text-teal-10" style="font-family: Lato"><b>Person To Tutor</b>: <text class="text-black">{{item.sessionCreator}}</text></p>

            </q-card-section>

            <q-separator />

            <q-card-actions align="right">
              <q-btn flat label="Got the info, thanks!" color="red-10" v-close-popup style="font-family: Lato" no-caps/>

            </q-card-actions>
          </q-card>
        </q-dialog>

        <q-dialog v-model="cancelSessionDialog[n]" no-esc-dismiss no-backdrop-dismiss>
          <q-card flat bordered style="width: 40vw">
            <q-card-section>
              <div class="text-h5 q-mb-xs-xs" style="font-family: Lato">Cancel Session</div>
            </q-card-section>
            <q-separator />
            <q-card-section style="padding-top: 0.5vh">
              <p class="text-caption text-teal-10 " style="font-family: Lato; word-wrap: break-word">You are about to cancel the tutoring session. This will make it so that the session is fed back into the pool of open sessions. Please ensure that you have a valid reason to cancel; consistent patterns of cancellation may lead to eventual bans from <text class="text-bold" style="font-family: Montserrat; font-weight: 700">zerudite</text>.</p>
            </q-card-section>

            <q-separator />

            <q-card-actions align="right">
              <q-btn push label="Yes, Cancel Session" color="red-6" @click="cancelSession(n)" style="font-family: Lato" no-caps />
              <q-btn flat label="No, Go Back!" color="red-10" v-close-popup style="font-family: Lato" no-caps/>

            </q-card-actions>
          </q-card>
        </q-dialog>
        </div>

      </q-scroll-area>
    </q-tab-panel>


    <q-tab-panel name="search">
      <p class="text-h4" style="font-family: Montserrat; font-weight: 350"><b>Search</b> for a request</p>
      <div class="row" style="height: 2vh;"></div>

      <q-input color="teal-10" bg-color="white" outlined v-model="query" label="Look for a request" label-color="teal-10" style="font-family: Lato;" @change="getData()">
        <template v-slot:prepend>
          <q-icon name="search" color="grey" />
        </template>
      </q-input>


      <div class="row" style="height: 2vh;"></div>
      <div class="row inline">
        <q-select
            v-model="filterSubject"
            clearable
            use-input
            input-debounce="0"
            label="Filter by Subject"
            :options="options"
            @filter="filterFn"
            style="font-family: Lato; width: 15vw; margin-right: 1vw;"
            standout="bg-teal-10 text-white"
        />

        <q-select style="width: 10vw; font-family: Lato;" standout="bg-teal-10 text-white" v-model="sortSelect" :options="sortOptions" label="Sort By" />
      </div>
      <div class="row" style="height: 2vh"></div>
      <q-separator />
      <div class="row" style="height: 2vh"></div>

      <q-scroll-area style="height: 55vh">
        <div v-for="(item, i) in searchResults" :key="i">
          <q-card class="my-card bg-teal-3" flat bordered style="margin-bottom: 2.5vh">
            <q-item>
              <q-item-section avatar>
                <q-avatar @click="$router.replace('/profile/' + item.sessionCreatorUsername)">
                  <img v-bind:src="sessionsPFPSrcArr[i] === 'blank' ? require(`../assets/blank-avatar.png`) : sessionsPFPSrcArr[i]">
                </q-avatar>
              </q-item-section>

              <q-item-section>
                <div class="row" style="height: 4vh;">
                  <div class="col-3">
                    <q-item-label style="font-family: Lato">{{item.sessionCreator}}</q-item-label>
                    <q-item-label caption style="font-family: Lato">{{item.sessionTime}}
                    </q-item-label>
                  </div>

                  <q-separator vertical />

                  <div class="col-5" style="padding-left: 0.5vw">
                    <q-item-label class="text-bold" style="font-family: Lato">{{item.sessionSubjects}}</q-item-label>
                    <q-item-label caption class="text-bold" style="font-family: Lato">
                      {{item.sessionBounty}} Credits
                    </q-item-label>
                  </div>
                </div>
              </q-item-section>



            </q-item>

            <q-separator />

            <q-card-section horizontal>
              <div class="col-8">
                <q-card-section>
                  <text style="font-family: Lato; word-break: break-word">{{item.truncatedQuestion}}</text>
                </q-card-section>
              </div>
              <div class="col-2 q-pa-md text-center">
                <q-btn
                    round
                    color="teal"
                    icon="check"
                    @click="setAcceptConfirmDialog(i)"
                />
                <q-item-label caption class="text-bold" style="margin-top: 1vh; font-family: Lato">
                  Accept Request
                </q-item-label>
              </div>
              <div class="col-2 q-pa-md text-center">
                <q-btn
                    round
                    color="deep-orange-10"
                    icon="assignment"
                    @click="setMoreInfoDialog(i)"
                />
                <q-item-label caption class="text-bold" style="margin-top: 1vh; font-family: Lato;">
                  More Info
                </q-item-label>
              </div>
            </q-card-section>
          </q-card>

        <q-dialog v-model="moreInfoDialog[i]" no-esc-dismiss no-backdrop-dismiss>
          <q-card flat bordered style="width: 40vw">
            <q-card-section>
              <div class="text-h5 q-mb-xs-xs" style="font-family: Lato">Session Info</div>
            </q-card-section>
            <q-separator />
            <q-card-section style="padding-top: 0.5vh">
              <p class="text-caption text-teal-10 " style="font-family: Lato; word-wrap: break-word"><b>Question</b>: <text class="text-black">{{item.sessionQuestion}}</text></p>
              <p class="text-caption text-teal-10" style="font-family: Lato"><b>Date</b>: <text class="text-black">{{item.sessionTime.substr(0, 12)}}</text></p>
              <p class="text-caption text-teal-10" style="font-family: Lato"><b>Time</b>: <text class="text-black">{{item.sessionTime.substr(12)}}</text></p>
              <p class="text-caption text-teal-10" style="font-family: Lato"><b>Subjects</b>: <text class="text-black">{{item.sessionSubjects}}</text></p>
              <p class="text-caption text-teal-10" style="font-family: Lato"><b>Bounty</b>: <text class="text-black">{{item.sessionBounty}}</text></p>
              <p class="text-caption text-teal-10" style="font-family: Lato"><b>Person To Tutor</b>: <text class="text-black">{{item.sessionCreator}}</text></p>

            </q-card-section>

            <q-separator />

            <q-card-actions align="right">
              <q-btn flat label="Got the info, thanks!" color="red-10" v-close-popup style="font-family: Lato" no-caps/>

            </q-card-actions>
          </q-card>
        </q-dialog>

        <q-dialog v-model="acceptConfirmDialog[i]" no-esc-dismiss no-backdrop-dismiss>
          <q-card flat bordered style="width: 40vw">
            <q-card-section>
              <div class="text-h5 q-mb-xs-xs" style="font-family: Lato">Accept Session</div>
            </q-card-section>
            <q-separator />
            <q-card-section style="padding-top: 0.5vh">
              <p class="text-caption text-teal-10 " style="font-family: Lato; word-wrap: break-word"><b>Please attest to the following</b>: <text class="text-black">By clicking on the <b>Yes, Accept Session</b> below, I am consenting to tutor {{item.sessionCreator}} in {{item.sessionSubjects}} on {{item.sessionTime}}. If I am unable to attend, I will cancel the session acceptance within 48 hours of the session. I will tutor {{item.sessionCreator}} in a respectful and encouraging manner to create a suitable learning environment. If I do not follow these guidelines, I may be subject to penalties and eventual bans from <text class="text-bold" style="font-family: Montserrat; font-weight: 700">zerudite</text>.</text></p>
            </q-card-section>

            <q-separator />

            <q-card-actions align="right">
              <q-btn push label="Yes, Accept Session" color="teal-10" @click="acceptSession(i)" style="font-family: Lato" no-caps />
              <q-btn flat label="No, Go Back!" color="red-10" v-close-popup style="font-family: Lato" no-caps/>

            </q-card-actions>
          </q-card>
        </q-dialog>
        </div>
      </q-scroll-area>

    </q-tab-panel>

  </q-tab-panels>
  </div>
  <div class="col-6" v-else>
    <p
        class="text-h5"
        style="font-family: Lato; font-weight: 700; text-align: left; margin-bottom: 0"
    >
      You are not eligible to access this page!
    </p>
    <p
        class="text-h7"
        style="font-family: Lato; text-align: left; margin-bottom: 3vh"
    >
      To access this page and be able to tutor others, you must have verified your identity (by submitting a picture of your school/academic institution's ID) and filled out your subject profile. This is all possible in the profile page's <b>Verification and Subjects Profile</b> section.
    </p>

    <div v-if="verified">
      <q-icon name="check_circle_outline" color="teal-10" :size="'sm'" />
      <text
        class="text-h7"
        style="font-family: Lato; text-align: left; margin-bottom: 0"
    >
      You have verified yourself!
    </text>
    </div>
    <div v-else>
      <q-icon name="cancel" color="red-6" :size="'sm'" />
      <text
          class="text-h7"
          style="font-family: Lato; text-align: left; margin-bottom: 0"
      >
        You have not verified yourself!
      </text>
    </div>

    <div v-if="filledOutSubjects">
      <q-icon name="check_circle_outline" color="teal-10" :size="'sm'" />
      <text
          class="text-h7"
          style="font-family: Lato; text-align: left; margin-bottom: 0"
      >
        You have filled out your subjects profile!
      </text>
    </div>
    <div v-else>
      <q-icon name="cancel" color="red-6" :size="'sm'" />
      <text
          class="text-h7"
          style="font-family: Lato; text-align: left; margin-bottom: 0"
      >
        You have not filled out your subjects profile!
      </text>
    </div>



  </div>



  </div>


</template>

<script>
  import InternalNavBar from "@/components/internal-navbar";
  import {getCurrentInstance, ref} from 'vue'
  import firebase from "firebase";
  import 'datejs';
  import {Dialog} from "quasar";

  const constOptions = ["Accounting", "Business law", "Business management", "Consumer education", "Entrepreneurial skills", "Introduction to business", "Marketing ", "Personal finance", "Animation", "App development", "Audio production", "Computer programming", "Computer repair", "Film production", "Graphic design", "Keyboarding", "Media technology", "Music production", "Video game development", "Web design", "Web programming", "Word processing ", "AP Computer Science A", "AP Computer Science Principles", "American literature", "British literature", "Contemporary literature", "Creative writing", "Communication skills", "Debate", "English language and composition", "English literature and composition", "Humanities", "Journalism", "Literary analysis", "Modern literature", "Poetry", "Popular literature", "Rhetoric", "Shakespeare", "Technical writing", "World literature", "Written and oral communication", "AP English Language and Composition", "AP English Literature and Composition", "Chemistry of foods", "CPR training", "Culinary arts", "Early childhood development", "Early childhood education", "Family studies", "Fashion and retail merchandising", "Fashion construction", "Home economics", "Interior design", "Nutrition", "American Sign Language", "Ancient Greek", "Arabic", "Chinese", "French", "German", "Hebrew", "Italian", "Japanese", "Korean", "Latin", "Portuguese", "Russian", "Spanish", "AP Chinese Language and Culture", "AP French Language and Culture", "AP German Language and Culture", "AP Italian Language and Culture", "AP Japanese Language and Culture", "AP Latin", "AP Spanish Language and Culture", "AP Spanish Literature and Culture", "Algebra 1", "Algebra 2", "Calculus", "Computer math", "Consumer math", "Fundamentals of math", "Geometry", "Integrated math", "Math applications", "Multivariable calculus", "Practical math", "Pre-algebra", "Pre-calculus", "Probability", "Quantitative literacy", "Statistics", "Trigonometry", "AP Calculus AB", "AP Calculus BC", "AP Statistics", "Choir", "Concert band", "Dance", "Drama", "Guitar", "Jazz band", "Marching band", "Music theory", "Orchestra", "Percussion", "Piano ", "Theater technology", "World music", "Aerobics", "Dance", "Gymnastics", "Health", "Lifeguard training", "Pilates", "Racket sports", "Specialized sports", "Swimming", "Weight training", "Yoga", "Agriculture", "Astronomy", "Biology", "Botany", "Chemistry", "Earth science", "Electronics", "Environmental science", "Environmental studies", "Forensic science", "Geology", "Marine biology", "Oceanography", "Physical science", "Physics", "Zoology", "AP Biology", "AP Chemistry", "AP Environmental Science", "AP Physics C: Electricity and Magnetism", "AP Physics C: Mechanics", "AP Physics 1: Algebra-Based", "AP Physics 2: Algebra-Based", "Cultural anthropology", "Current events", "European history", "Geography", "Global studies", "Human geography", "International relations", "Law", "Macroeconomics", "Microeconomics", "Modern world studies", "Physical anthropology", "Political studies", "Psychology", "Religious studies", "Sociology", "US government", "US history", "Women’s studies", "World history", "World politics", "World religions", "AP Comparative Government and Politics", "AP European History", "AP Human Geography", "AP Macroeconomics", "AP Microeconomics", "AP Psychology", "AP United States Government and Politics", "AP United States History", "AP World History", "3-D art", "Art history", "Ceramics", "Digital media", "Drawing", "Film production", "Jewelry design", "Painting", "Photography", "Printmaking", "Sculpture", "AP Art History", "AP Music Theory", "AP Studio Art: 2-D Design", "AP Studio Art: 3-D Design", "AP Studio Art: Drawing", "Auto body repair", "Auto mechanics", "Building construction", "Computer-aided drafting", "Cosmetology", "Criminal justice", "Driver education", "Electronics", "FFA", "Fire science", "Heating and cooling systems", "Hospitality and tourism", "JROTC", "Metalworking", "Networking", "Plumbing", "Production technology", "Refrigeration fundamentals", "Robotics", "Woodworking"]
  export default {
    setup () {
      const internalInstance = getCurrentInstance()
      var options = ref(constOptions)
      var query = ref(null)

      var searchResults = ref([])
      var sessionsPFPSrcArr = ref([])
      var moreInfoDialog = ref([])
      var acceptConfirmDialog = ref([])

      var upcomingSessions = ref([])
      var upcomingSessionsPFPSrcArr = ref([])
      var upcomingMoreInfoDialog = ref([])
      var cancelSessionDialog = ref([])
      var upcomingCanJoinSession = ref([])


      var verified = ref(false)
      var filledOutSubjects = ref(false)

      return {
        filterSubject: ref(null),
        sortSelect: ref(null),
        tab: ref('search'),
        options,
        searchResults,
        query,
        internalInstance,
        sessionsPFPSrcArr,
        moreInfoDialog,
        acceptConfirmDialog,
        upcomingSessions,
        upcomingSessionsPFPSrcArr,
        upcomingMoreInfoDialog,
        cancelSessionDialog,
        upcomingCanJoinSession,
        verified,
        filledOutSubjects,
        filterFn (val, update) {
          if (val === '') {
            update(() => {
              options.value = constOptions

              // here you have access to "ref" which
              // is the Vue reference of the QSelect
            })
            return
          }

          update(() => {
            const needle = val.toLowerCase()
            options.value = constOptions.filter(v => v.toLowerCase().indexOf(needle) > -1)
          })
        },
        sortOptions: ['Sort by Relevance', 'Sort by Bounty']
      }
    },
    name: "Name",
    components: {
      InternalNavBar,
    },
    methods: {
      setMoreInfoDialog(i) {
        this.moreInfoDialog[i] = true
      },
      setAcceptConfirmDialog(i) {
        this.acceptConfirmDialog[i] = true
      },
      setUpcomingMoreInfoDialog(i) {
        this.upcomingMoreInfoDialog[i] = true
      },
      setCancelSessionDialog(i) {
        this.cancelSessionDialog[i] = true
      },
      async acceptSession(i) {
        let url = this.internalInstance.appContext.config.globalProperties.$backendURL
        await firebase.auth().onAuthStateChanged(async (user) => {
          let IDToken = await user.getIdToken(true)
          let response = await fetch(url + '/acceptSession', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              token: IDToken,
              sessionID: this.searchResults[i]._id
            })
          })
          let result = await response.json()
          if (result.code !== 'SUCCESSFUL') {
            Dialog.create({
              title: 'Session Not Accepted',
              message: "An error occurred. Please try again. \nError: " + result.code.toString(),
              persistent: true
            }).onOk(() => {
              // console.log('OK')
            }).onCancel(() => {
              // console.log('Cancel')
            }).onDismiss(() => {
              // console.log('I am triggered on both OK and Cancel')
            })
          } else {
            Dialog.create({
              title: 'Session Accepted',
              message: "The session has been accepted! Prepare for tutoring " + this.searchResults[i].sessionCreator + " on " + this.searchResults[i].sessionTime,
              persistent: true
            }).onOk(() => {
              // console.log('OK')
            }).onCancel(() => {
              // console.log('Cancel')
            }).onDismiss(() => {
              // console.log('I am triggered on both OK and Cancel')
            })
          }
          this.acceptConfirmDialog[i] = false
        })
      },
      async cancelSession(i) {
        let url = this.internalInstance.appContext.config.globalProperties.$backendURL
        await firebase.auth().onAuthStateChanged(async (user) => {
          let IDToken = await user.getIdToken(true)
          let response = await fetch(url + '/unAcceptSession', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              token: IDToken,
              sessionID: this.upcomingSessions[i]._id
            })
          })
          let result = await response.json()
          if (result.code !== 'SUCCESSFUL') {
            Dialog.create({
              title: 'Session Not Cancelled',
              message: "An error occurred. Please try again. \nError: " + result.code.toString(),
              persistent: true
            }).onOk(() => {
              // console.log('OK')
            }).onCancel(() => {
              // console.log('Cancel')
            }).onDismiss(() => {
              // console.log('I am triggered on both OK and Cancel')
            })
          } else {
            Dialog.create({
              title: 'Session Cancelled',
              message: "The session has been cancelled.",
              persistent: true
            }).onOk(() => {
              // console.log('OK')
            }).onCancel(() => {
              // console.log('Cancel')
            }).onDismiss(() => {
              // console.log('I am triggered on both OK and Cancel')
            })
          }
          this.cancelSessionDialog[i] = false
        })
      },
      async getData() {
        if (this.query === "") {
          await this.onMounted()
          return
        }
        let url = this.internalInstance.appContext.config.globalProperties.$backendURL
        await firebase.auth().onAuthStateChanged(async (user) => {
          let IDToken = await user.getIdToken(true)
          let response = await fetch(url + '/findSessions', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              token: IDToken,
              searchQuery: this.query,
              sortByBounty: this.sortSelect === 'Sort by Bounty',
              filteredSubject: this.filterSubject,
            })
          })
          let result = await response.json()

          if (result.code !== "SUCCESSFUL") {
            Dialog.create({
              title: 'An error occurred',
              message: "An error occurred. Please try again. \nError: " + result.code.toString(),
              persistent: true
            }).onOk(() => {
              // console.log('OK')
            }).onCancel(() => {
              // console.log('Cancel')
            }).onDismiss(() => {
              // console.log('I am triggered on both OK and Cancel')
            })
            return
          }

          let itemsArr = result.result
          this.searchResults = await JSON.parse(itemsArr)
          for (let i = 0; i < this.searchResults.length; i++) {
            this.moreInfoDialog.push(false)
            this.acceptConfirmDialog.push(false)

            let subjectsString = ""
            let sessionSubjects = this.searchResults[i].sessionSubjects
            for (let j = 0; j < sessionSubjects.length; j++) {
              subjectsString = subjectsString + sessionSubjects[j].toString() + ", "
            }
            subjectsString = subjectsString.substr(0, subjectsString.length - 2)
            this.searchResults[i].sessionSubjects = subjectsString

            this.searchResults[i].truncatedQuestion = this.searchResults[i].sessionQuestion.substr(0, 240)
            if (this.searchResults[i].sessionQuestion.length > 240) {
              this.searchResults[i].truncatedQuestion = this.searchResults[i].truncatedQuestion + "..."
            }

            const constdate = new Date()
            let time = new Date(this.searchResults[i].sessionTime).getTime()
            let offset = constdate.getTimezoneOffset() * 60000
            let newDate = new Date(time - offset)
            this.searchResults[i].sessionTime = Date.parse(newDate).toString("MMM dd, yyyy HH:mm")



            let response = await fetch(url + '/getPFP', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                username: this.searchResults[i].sessionCreatorUsername
              })
            })
            let result = await response.json()
            this.sessionsPFPSrcArr[i] = result.image == null ? "blank" : "data:image/png;base64," + result.image
          }
        })
      },
      async onMounted() {
        let url = this.internalInstance.appContext.config.globalProperties.$backendURL
        await firebase.auth().onAuthStateChanged(async (user) => {
          let IDToken = await user.getIdToken(true)

          let response = await fetch(url + '/getUserProfileDataUID', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              token: IDToken
            })
          })
          let result = await response.json()

          this.verified = result.profileData.verified
          this.filledOutSubjects = result.profileData.subjects.length > 0


          response = await fetch(url + '/getTutoringSessions', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              token: IDToken,
            })
          })
          result = await response.json()

          this.upcomingSessions = result.sessions

          for (let i = 0; i < this.upcomingSessions.length; i++) {
            this.cancelSessionDialog.push(false)
            this.upcomingMoreInfoDialog.push(false)

            let subjectsString = ""
            let sessionSubjects = this.upcomingSessions[i].sessionSubjects
            for (let j = 0; j < sessionSubjects.length; j++) {
              subjectsString = subjectsString + sessionSubjects[j].toString() + ", "
            }
            subjectsString = subjectsString.substr(0, subjectsString.length - 2)
            this.upcomingSessions[i].sessionSubjects = subjectsString

            this.upcomingSessions[i].truncatedQuestion = this.upcomingSessions[i].sessionQuestion.substr(0, 240)
            if (this.upcomingSessions[i].sessionQuestion.length > 240) {
              this.upcomingSessions[i].truncatedQuestion = this.upcomingSessions[i].truncatedQuestion + "..."
            }

            const constdate = new Date()
            let time = new Date(this.upcomingSessions[i].sessionTime).getTime()
            let offset = constdate.getTimezoneOffset() * 60000
            let newDate = new Date(time - offset)
            this.upcomingSessions[i].sessionTime = Date.parse(newDate).toString("MMM dd, yyyy HH:mm")

            this.upcomingCanJoinSession[i] = newDate.getTime() - constdate.getTime() <= 86400000

            let response = await fetch(url + '/getPFP', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                username: this.upcomingSessions[i].sessionCreatorUsername
              })
            })
            let result = await response.json()
            this.upcomingSessionsPFPSrcArr[i] = result.image == null ? "blank" : "data:image/png;base64," + result.image
          }

          response = await fetch(url + '/findRecommendedSessions', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              token: IDToken,
            })
          })
          result = await response.json()

          this.searchResults = result.sessions

          for (let i = 0; i < this.searchResults.length; i++) {
            this.moreInfoDialog.push(false)
            this.acceptConfirmDialog.push(false)

            let subjectsString = ""
            let sessionSubjects = this.searchResults[i].sessionSubjects
            for (let j = 0; j < sessionSubjects.length; j++) {
              subjectsString = subjectsString + sessionSubjects[j].toString() + ", "
            }
            subjectsString = subjectsString.substr(0, subjectsString.length - 2)
            this.searchResults[i].sessionSubjects = subjectsString

            this.searchResults[i].truncatedQuestion = this.searchResults[i].sessionQuestion.substr(0, 240)
            if (this.searchResults[i].sessionQuestion.length > 240) {
              this.searchResults[i].truncatedQuestion = this.searchResults[i].truncatedQuestion + "..."
            }

            const constdate = new Date()
            let time = new Date(this.searchResults[i].sessionTime).getTime()
            let offset = constdate.getTimezoneOffset() * 60000
            let newDate = new Date(time - offset)
            this.searchResults[i].sessionTime = Date.parse(newDate).toString("MMM dd, yyyy HH:mm")



            let response = await fetch(url + '/getPFP', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                username: this.searchResults[i].sessionCreatorUsername
              })
            })
            let result = await response.json()
            this.sessionsPFPSrcArr[i] = result.image == null ? "blank" : "data:image/png;base64," + result.image
          }
        })
      }
    },
    async mounted() {
      await this.onMounted()
    }
  }
</script>
<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');


.lato {
  font-family: Lato;
}

.text-caption {
  margin-bottom: 0vh;
}
</style>